import { getPropsWithCompliantTitleId } from './appIdUtils';
import type { LogModules } from './enum';
import { type LogLevel } from './enum';
import type { PropertiesType } from './types/PropertiesType';
import { logCoreUsage } from 'owa-analytics';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

/**
 * @function
 * To log Error messages
 */
export const logError = (
    logModule: LogModules,
    logMessage: string,
    _appId: string,
    correlationId: string,
    properties?: PropertiesType
): void => {
    let propsWithCompliantTitleId: PropertiesType = {};
    if (properties) {
        propsWithCompliantTitleId = getPropsWithCompliantTitleId(properties);
    }
    /* eslint-disable-next-line owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
     * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
     *	> Invalid Outlook telemetry EventName "message_extension_logs": must start with a capital letter (A–Z). */
    logCoreUsage('message_extension_logs', getModuleContextMailboxInfo(), {
        LogLevel: 'Error',
        LogModule: logModule,
        LogMessage: logMessage,
        CorrelationId: correlationId ? correlationId : '',
        ...propsWithCompliantTitleId,
    });
};

/**
 * @function
 * To log Warnings
 */
export const logWarning = (
    logModule: LogModules,
    logMessage: string,
    _appId: string,
    correlationId: string,
    properties?: PropertiesType
): void => {
    let propsWithCompliantTitleId: PropertiesType = {};
    if (properties) {
        propsWithCompliantTitleId = getPropsWithCompliantTitleId(properties);
    }
    /* eslint-disable-next-line owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
     * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
     *	> Invalid Outlook telemetry EventName "message_extension_logs": must start with a capital letter (A–Z). */
    logCoreUsage('message_extension_logs', getModuleContextMailboxInfo(), {
        LogLevel: 'Warning',
        LogModule: logModule,
        LogMessage: logMessage,
        CorrelationId: correlationId ? correlationId : '',
        ...propsWithCompliantTitleId,
    });
};

/**
 * @function
 * To log Information
 */
export const logInfo = (
    logModule: LogModules,
    logMessage: string,
    _appId: string,
    correlationId: string,
    properties?: PropertiesType
): void => {
    let propsWithCompliantTitleId: PropertiesType = {};
    if (properties) {
        propsWithCompliantTitleId = getPropsWithCompliantTitleId(properties);
    }
    /* eslint-disable-next-line owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
     * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
     *	> Invalid Outlook telemetry EventName "message_extension_logs": must start with a capital letter (A–Z). */
    logCoreUsage('message_extension_logs', getModuleContextMailboxInfo(), {
        LogLevel: 'Info',
        LogModule: logModule,
        LogMessage: logMessage,
        CorrelationId: correlationId ? correlationId : '',
        ...propsWithCompliantTitleId,
    });
};

/**
 * @function
 * To log user actions
 */
export const logAction = (
    logModule: LogModules,
    action: string,
    _appId: string,
    correlationId: string,
    properties?: PropertiesType
): void => {
    let propsWithCompliantTitleId: PropertiesType = {};
    if (properties) {
        propsWithCompliantTitleId = getPropsWithCompliantTitleId(properties);
    }
    // Message extension user action logging
    /* eslint-disable-next-line owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
     * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
     *	> Invalid Outlook telemetry EventName "message_extension_actions": must start with a capital letter (A–Z). */
    logCoreUsage('message_extension_actions', getModuleContextMailboxInfo(), {
        LogModule: logModule,
        Action: action,
        AppId: '',
        CorrelationId: correlationId ? correlationId : '',
        ...propsWithCompliantTitleId,
    });
};
